import styled from "styled-components"

import {
  Box,
  ButtonLink,
  Heading,
  Text,
  TitleGroup,
} from "../components/elements"
const simulators = [
  {
    key: "bpo",
    title: "アウトソーシング見積もり",
    description: "アウトソーシングをされた場合の見積もりが算出できます",
    to: "/bpo",
  },
  {
    key: "platform",
    title: "導入効果",
    description: "ジョーシス導入によるコストシミュレーションができます",
    to: "/platform",
  },
]

const StyledText = styled(Text)`
  font-size: clamp(0.7rem, 0.64rem + 0.3vw, 1rem);
`

const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  column-gap: clamp(1rem, 0.8rem + 1vw, 2rem);
  row-gap: 2rem;
  margin-top: clamp(3rem, 2.7rem + 1.5vw, 4.5rem);
  width: 100%;
`

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: ${(props) => props.theme.colors.boxBackground};
  padding: clamp(1.2rem, 0.84rem + 1.8vw, 3rem);
  width: minmax(80%, 30rem);

  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
`

const CardDescription = styled.span`
  margin-top: 0.75em;
  margin-bottom: 2.5em;
  flex-grow: 1;
  vertical-align: top;

  // text
  font-size: 0.75rem;
  font-size: clamp(0.75rem, 0.725rem + 0.125vw, 0.875rem);
  font-weight: 500;
  line-height: 150%;
  letter-spacing: 0.05em;
  text-align: center;
`

const Home = () => {
  return (
    <Box flexDirection="column" fullwidth>
      <TitleGroup>
        <Heading level="h1">シミュレーター</Heading>
        <StyledText primary>
          ジョーシス導入効果をシミュレーションできます
        </StyledText>
      </TitleGroup>
      <CardContainer>
        {simulators.map((simulator) => (
          <Card key={simulator.key}>
            <Heading level="h2">
              {simulator.title}
              <br />
              シミュレーター
            </Heading>
            <CardDescription>{simulator.description}</CardDescription>{" "}
            <ButtonLink to={simulator.to} $fullwidth>
              シミュレーションする
            </ButtonLink>
          </Card>
        ))}
      </CardContainer>
    </Box>
  )
}

export { Home }
